import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FuelIssueIndentComponent } from "./FuelIssueIndent.component";
import { Routes, RouterModule } from "@angular/router";
import { DefaultComponent } from "../../theme/pages/default/default.component";
// import { FuelIssueIndentRoutingModule } from "./FuelIssueIndent-routing.routing";
import { LayoutModule } from "../../theme/layouts/layout.module";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../../freightconfirmation/app.sharemodule";
import { NumberToWordsPipeFuelIssueIndent } from './number-to-wordsFuelIssueIndent.pipe';
import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule, TranslateService, } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

const routes: Routes = [
    {
        path: "",
        component: DefaultComponent,
        children: [
            {
                path: "",
                component: FuelIssueIndentComponent,
            },
        ],
    },
];

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        FormsModule,
        SharedModule,
        // FuelIssueIndentRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
    ],
    declarations: [FuelIssueIndentComponent, NumberToWordsPipeFuelIssueIndent],
    exports: [FuelIssueIndentComponent],
    providers: [TranslateConfigService],
})
export class FuelIssueIndentModule { }
